import { Member } from "../../members/models/Member";
import { InviteeType } from "../models/InviteeType";
import { MemberSeat } from "../models/MemberSeat";
import { Session } from "../models/Session";

/**
 * True when the member is on the Session's series roster: invited on their own (or as a
 * per-member group row), or through one of their groups. One-off invitees don't count.
 */
export const isOnSessionRoster = (session: Session, member: Member): boolean => {
  const groupIds = new Set((member.groups ?? []).map((g) => g.id));
  return session.invitees.some(
    (inv) =>
      inv.type !== InviteeType.OneOff &&
      (inv.invitedUserId === member.id || (inv.type === InviteeType.Group && groupIds.has(inv.invitedUserId))),
  );
};

/** The dates of one Session the member already holds a seat on (either status). */
export const heldSeatDates = (seats: MemberSeat[], bookingId: string): Set<string> =>
  new Set(seats.filter((s) => s.bookingId === bookingId).map((s) => s.date));
